export interface IMicrositeCampaignValidatedMailingList {
    id: number,
    columns: string[],
    errors: string[],
    rowMissingData: boolean
}